export default function OrderSummary(){
        return (
            <>
            <div className="container text-center py-5 my-5">
                <h1 className="my-5">Thank You for Shopping With Us!</h1>
                <h5 className="mb-5">you'll receive order details in email soon..</h5>
            </div>
            </>
        )
}